<template>
  <div id="app">
    <PageContainer>
      <PageHeader
        v-if="showHeader"
        :active-params="navCurrentRouteParams"
        :active="navCurrentRoute"
        :advanced-search-route="advancedSearchRoute"
        :application-languages="applicationLanguages"
        :logo="`${serviceName}-${uiLanguage}`"
        :nav-items="extraNav"
        :suggestion-items="suggestionItems"
        :ui-language="uiLanguage"
        @clear-suggest="clearSuggest"
        @get-suggest="getSuggest"
        @search-global="searchGlobal"
      />
      <BaseNav
        v-if="showNav"
        :active="navCurrentRoute"
        :anchor="$route.hash"
        :items="navItems"
        :ui-language="uiLanguage"
        variant="global"
        orientation="horizontal"
      />
      <router-view />
      <PageFooter
        v-if="showFooter"
        :options-page-footer-branding="optionsPageFooter.PageFooterBranding"
        :options-page-footer-links="optionsPageFooter.PageFooterLinks"
        :options-page-footer-other-services="optionsPageFooter.PageFooterOtherServices"
        :ui-language="uiLanguage"
      />
    </PageContainer>
  </div>
</template>

<script>
import AppBase from "@wrappers/mixins/AppBase.vue"
import AppSearchSuggest from "@wrappers/mixins/AppSearchSuggest.vue"
import storeTypes from "@common/config/store-types"

export default {
  name: "App",
  mixins: [
    AppBase,
    AppSearchSuggest,
  ],
  created() {
    this.$store.dispatch(`static/${storeTypes.FETCH_GLOBALLY_REQUIRED_INFORMATION}`)
  },
}
</script>

<style lang="scss" scoped>
  // Fonts
  @import "https://fonts.googleapis.com/css?family=Fira+Sans+Condensed";
  @import "https://fonts.googleapis.com/css?family=Fira+Sans";

  // Import tokens and style for #app
  @import "@almamedia/lex-ds/dist/tukes/tokens/tokens";
  @import "@almamedia/lex-ds/src/styles/common";
  @import "@almamedia/lex-ds/src/styles/print";
</style>
